// extracted by mini-css-extract-plugin
module.exports = {"button":"text-modal_component_button__XEjL3","textModal":"text-modal_component_textModal__PdHru"};